import { createElement } from '../../../core/dom/helpers.js';
import { attachCharCounter } from '../../../core/dom/char-counter.js';

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const textareaDriver = {
  type: 'textarea',
  mount(container, ctx) {
    const { def, onChange } = ctx;

    const textarea = /** @type {HTMLTextAreaElement} */ (createElement('textarea', {
      id: `field-${def.key}`,
      name: def.key,
      class: 'form-field-input',
    }));
    if (def.placeholder) textarea.setAttribute('placeholder', def.placeholder);
    if (def.required) { textarea.setAttribute('required', 'required'); textarea.setAttribute('aria-required', 'true'); }
    if (def.disabled) textarea.setAttribute('disabled', 'disabled');
    textarea.addEventListener('input', () => onChange(textarea.value));

    container.appendChild(textarea);

    if (ctx.value !== undefined) {
      textarea.value = ctx.value == null ? '' : String(ctx.value);
    }

    const counter = def.maxLength ? attachCharCounter(textarea, def.maxLength) : null;

    return {
      setValue(value) {
        textarea.value = value == null ? '' : String(value);
      },
      getValue() {
        return textarea.value;
      },
      setErrors() {
        // errors rendered by host
      },
      destroy() {
        counter?.destroy();
        textarea.remove();
      },
      setDisabled(disabled) {
        textarea.disabled = disabled;
      },
      clearValue() {
        textarea.value = '';
      },
      setAriaInvalid(invalid) {
        textarea.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      },
    };
  },
};
